/* eslint-disable */
import { Button, FormHelperText, Grid, InputAdornment, TextField, Typography } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import withWidth from '@material-ui/core/withWidth';
import AddIcon from '@material-ui/icons/Add';
import RemoveIcon from '@material-ui/icons/Remove';
import WatchIcon from '@material-ui/icons/Watch';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { bindActionCreators, compose } from 'redux';
import withServices from '../../Contexts/Services/WithServices.context';
import docketsActionCreators from '../../State/Store/Dockets/Dockets.actions';
import filtersActionCreators from '../../State/Store/Filters/Filters.actions';
import getFiltersSelectedAccount from '../../State/Store/Filters/Selectors/FiltersSelectedAccount.selector';
import uiActionCreators from '../../State/Store/UI/UI.actions';
import { UI_TRUCK_SPACING_SELECTOR_DECREASE, UI_TRUCK_SPACING_SELECTOR_INCREASE } from '../../State/Store/UI/UI.types';
import userProfileSelector from '../../State/Store/UserProfile/Selectors/UserProfileCurrent.selector';
import themeCreateInjectableStyles from '../../Support/Theme/CreateInjectableStyles/ThemeCreateInjectableStyles.support';
import placeOrderStyles from './PlaceOrder.component.styles';
import PlaceOrderErrorMessage from './PlaceOrderErrorMessage.component';

/**
 * TruckSpacing
 * @param {any} props The props
 * @returns {React.Component} The component
 */
const TruckSpacing = ({ actions, classes, pourMethod, onChange, isEdit, defaultSpacing, mandatoryFieldError }) => {
  const [isValid, setIsValid] = useState(true);

  const pourMethods = {
    '2PMP': 10,
    BOOM: 15,
    CHUT: 30,
    CRAN: 30,
    KERB: 30,
    L: 20,
    WB: 45,
  };

  const [spacing, setSpacing] = useState(0);

  useEffect(() => {
    if (pourMethod) {
      setSpacing(pourMethods[pourMethod.code]);
      if (!isEdit) {
        onChange({ selectedTruckSpacing: pourMethods[pourMethod.code], isValid: true });
      }
      setIsValid(true);
    }
  }, [pourMethod]);

  /**
   * Increase spacing
   * @returns {void} void
   */
  const increase = () => {
    actions.uiTriggered({
      payload: {
        data: {
          name: `truckSpacingSelectorIncrease`,
        },
      },
      type: UI_TRUCK_SPACING_SELECTOR_INCREASE,
    });

    const cleanedUpTruckSpacing = `${spacing}`.replace(/[^0-9\.]/g, ``).replace(/\.{2,}/g, `.`) * 1;
    let updatedTruckSpacing = 0;
    if (!cleanedUpTruckSpacing) {
      updatedTruckSpacing = 5;
    } else if ((cleanedUpTruckSpacing + 5).toFixed(1) * 1 > 60) {
      updatedTruckSpacing = cleanedUpTruckSpacing + 5;
      updatedTruckSpacing = updatedTruckSpacing.toFixed(1) * 1;
      setSpacing(updatedTruckSpacing);
      onChange({ selectedTruckSpacing: updatedTruckSpacing, isValid: false });
      setIsValid(false);
      return;
    } else {
      updatedTruckSpacing = (cleanedUpTruckSpacing + 5).toFixed(1) * 1;
      if ((updatedTruckSpacing * 10) % 5) {
        updatedTruckSpacing = Math.floor(updatedTruckSpacing);
        updatedTruckSpacing = updatedTruckSpacing.toFixed(1) * 1;
      }
    }
    setSpacing(updatedTruckSpacing);
    onChange({ selectedTruckSpacing: updatedTruckSpacing, isValid: true });
    setIsValid(true);
    return;
  };

  /**
   * Decrease spacing and report to analytics
   * @returns {void} void
   */
  const decrease = () => {
    actions.uiTriggered({
      payload: {
        data: {
          name: `truckSpacingSelectorDecrease`,
        },
      },
      type: UI_TRUCK_SPACING_SELECTOR_DECREASE,
    });

    const cleanedUpTruckSpacing = `${spacing}`.replace(/[^0-9\.]/g, ``).replace(/\.{2,}/g, `.`);
    let updatedTruckSpacing = 0;
    if (!spacing) {
      return;
    }
    updatedTruckSpacing = (cleanedUpTruckSpacing - 5).toFixed(1) * 1;
    if (!updatedTruckSpacing) {
      setSpacing(0);
      onChange({ cleanedUpTruckSpacing: 0, isValid: false });
      setIsValid(false);
    } else if (updatedTruckSpacing > 60 || updatedTruckSpacing < 5) {
      setSpacing(updatedTruckSpacing);
      onChange({ selectedTruckSpacing: updatedTruckSpacing, isValid: false });
      setIsValid(false);
    } else if (((updatedTruckSpacing * 1).toFixed(1) * 10) % 5) {
      updatedTruckSpacing = Math.floor(updatedTruckSpacing);
      setSpacing(updatedTruckSpacing);
      onChange({ selectedTruckSpacing: updatedTruckSpacing, isValid: true });
      setIsValid(true);
    } else {
      setSpacing(updatedTruckSpacing);
      onChange({ selectedTruckSpacing: updatedTruckSpacing, isValid: true });
      setIsValid(true);
    }
    return;
  };

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Grid container spacing={2} alignItems="center" className={classes.flexWrapNowrap}>
          <Grid item className={classes.flexGrow1}>
            <TextField
              error={mandatoryFieldError}
              fullWidth
              disabled={isEdit}
              id="                                                                                         "
              value={defaultSpacing || spacing || ``}
              label="Truck Spacing (mins)"
              className={classes.spacingField}
              placeholder="0.0"
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <WatchIcon className={classes.opacity05} />
                  </InputAdornment>
                ),
                endAdornment: (
                  <InputAdornment position="start">
                    <Typography variant="body1">minutes</Typography>
                  </InputAdornment>
                ),
              }}
            />
            {!isEdit && <FormHelperText>Recommended truck spacing is based on your product configuration</FormHelperText>}
          </Grid>
          {!isEdit && (
            <Grid item>
              <Button variant="outlined" onClick={decrease}>
                <RemoveIcon />
              </Button>
            </Grid>
          )}
          {!isEdit && (
            <Grid item>
              <Button variant="outlined" onClick={increase}>
                <AddIcon />
              </Button>
            </Grid>
          )}
        </Grid>
      </Grid>
      {!isValid && (
        <Grid item xs={12}>
          <PlaceOrderErrorMessage
            message={
              <Typography variant="body2" className={classes.errorText}>
                This spacing of the selected product cannot be ordered online. Please{` `}
                <a
                  className={classes.errorText}
                  rel="noopener noreferrer"
                  target="_blank"
                  href="https://www.boral.com.au/locations?product_category%5B86%5D=86"
                >
                  Call Boral
                </a>
                {` `}
                to place your order
              </Typography>
            }
          />
        </Grid>
      )}
    </Grid>
  );
};

/* eslint-disable react/forbid-prop-types */
/* eslint-disable react/require-default-props */
TruckSpacing.propTypes = {
  actions: PropTypes.object.isRequired,
  classes: PropTypes.object.isRequired,
  onChange: PropTypes.func,
  pourMethod: PropTypes.object,
  isEdit: PropTypes.bool,
  defaultSpacing: PropTypes.number,
};

export default compose(
  withWidth(),
  withRouter,
  withServices,
  connect(
    (state) => ({
      listSettings: state.dockets ? state.dockets.listSettings : null,
      userInfo: userProfileSelector(state),
      currentDateTimeGlobal: getFiltersSelectedAccount(state),
    }),
    (dispatch) => ({
      actions: bindActionCreators(
        {
          ...uiActionCreators,
          ...filtersActionCreators,
          ...docketsActionCreators,
        },
        dispatch,
      ),
    }),
  ),
  withStyles(themeCreateInjectableStyles(placeOrderStyles), { withTheme: true }),
)(TruckSpacing);
